export default __webpack_public_path__ + "04ba90ba85a6fbb48de7daeb856fbf87.png";